import { Injectable } from "@angular/core";

@Injectable({
	providedIn: "root",
})
export class WindowRef {
	private _native = typeof window === "object" ? window : {};

	// todo: https://github.com/angular/angular/issues/15640
	/**
	 * Window underlying native object
	 */
	get native(): Window {
		return this._native as Window;
	}
}
